export const accommodationTypes = [
  { label: 'Basic', value: 1 },
  { label: 'Standard', value: 2 },
  { label: 'Business', value: 3 },
  { label: 'Executive', value: 4 },
]
export const accommodationCategories = [
  { label: 'Apartment', value: 1 },
  { label: 'Townhouse', value: 2 },
]
